import { AdminSiteManagementWizardBackButtonActionNames } from '@/constants/admin-site-management'

export const enum OrgSiteManagementDeviceTypes {
  Tracker = 'Vibe + Tracker',
  Scale = 'Scale',
  PulseOximeter = 'Pulse Oximeter',
  Thermometer = 'Thermometer',
  Inhaler = 'Inhaler',
  BloodPressureMonitor = 'Vital Sign Machine',
  Glucometer = 'Glucometer',
}
// export const AdminSiteManagementDeviceTypeNames = {
//   [AdminSiteManagementDeviceTypes.Tracker]: 'Vibe + Tracker',
//   [AdminSiteManagementDeviceTypes.Scale]: 'Scale',
//   [AdminSiteManagementDeviceTypes.PulseOximeter]: 'Pulse Oximeter',
//   [AdminSiteManagementDeviceTypes.Thermometer]: 'Thermometer',
//   [AdminSiteManagementDeviceTypes.Inhaler]: 'Inhaler',
//   [AdminSiteManagementDeviceTypes.BloodPressureMonitor]: 'Vital Sign Machine',
//   [AdminSiteManagementDeviceTypes.Glucometer]: 'Glucometer',
// }
export const OrgSiteManagementDeviceTypeUploadKeys = {
  [OrgSiteManagementDeviceTypes.Tracker]: 'vibe-tracker',
  [OrgSiteManagementDeviceTypes.Scale]: 'scale',
  [OrgSiteManagementDeviceTypes.PulseOximeter]: 'pulse-oximeter',
  [OrgSiteManagementDeviceTypes.Thermometer]: 'thermometer',
  [OrgSiteManagementDeviceTypes.Inhaler]: 'inhaler',
  [OrgSiteManagementDeviceTypes.BloodPressureMonitor]: 'vital-sign-machine',
  [OrgSiteManagementDeviceTypes.Glucometer]: 'glucometer',
}

export const enum OrgSiteManagementWizardNextButtonActionNames {
  NextWizardStage = 'goToNextWizardStage',
  // NextSelectedDevice = 'goToNextSelectedDevice',
  // Confirm = 'confirm',
}

export const enum OrgSiteManagementWizardBackButtonActionNames {
  PreviousWizardStage = 'goToPreviousWizardStage',
  PreviousSelectedDevice = 'goToPreviousSelectedDevice',
}

export type OrgSiteManagementDevice = {
  type: string | null
  deviceId: string | null
  isSelected: boolean
  deviceIndex: number | null
  quantity: number
  units: Array<OrgSiteManagementUnit> | null
}

export type OrgSiteManagementUnit = {
  serialNumber: string | null
}

export function needsSerialNumber(type) {
  switch (type) {
    case OrgSiteManagementDeviceTypes.BloodPressureMonitor:
      return true
    case OrgSiteManagementDeviceTypes.Glucometer:
      return true
    default:
      return false
  }
}

export const OrgSiteManagementDefaultDevice = {
  type: null,
  deviceId: null,
  isSelected: false,
  deviceIndex: null,
  quantity: 1,
  units: null,
}

export const enum OrgSiteManagementComponents {
  SelectSite = 'OrgSiteManagementSelectSite',
  SelectUnit = 'OrgSiteManagementSelectUnit',
  ManageUnit = 'OrgSiteManagementManageUnit',

  // SelectDevices = 'OrgSiteManagementAddDevices',
  // AddSerialNumbers = 'OrgSiteManagementAddDeviceSerialNumbers',
  // Review = 'OrgSiteManagementReview',
  // Done = 'OrgSiteManagementDone',
}

export const OrgSiteManagementWizardStages = [
  {
    title: 'Select Site',
    component: OrgSiteManagementComponents.SelectSite,
    nextButtonText: 'Next',
    nextButtonAction: OrgSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: {},
  },
  {
    title: 'Select Unit',
    component: OrgSiteManagementComponents.SelectUnit,
    nextButtonText: 'Next',
    nextButtonAction: OrgSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: OrgSiteManagementWizardBackButtonActionNames.PreviousWizardStage,
  },
  {
    title: 'Manage Unit',
    component: OrgSiteManagementComponents.ManageUnit,
    nextButtonText: 'Cancel',
    nextButtonAction: OrgSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: OrgSiteManagementWizardBackButtonActionNames.PreviousWizardStage,
  },
]
